import { render } from "./NewsPublicFilter.vue?vue&type=template&id=21271990&scoped=true"
import script from "./NewsPublicFilter.vue?vue&type=script&lang=js"
export * from "./NewsPublicFilter.vue?vue&type=script&lang=js"

import "./NewsPublicFilter.vue?vue&type=style&index=0&id=21271990&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21271990"]])

export default __exports__